import React, { CSSProperties, useContext } from 'react';
import styles from './index.scss';
import { TranslationsContext } from 'common/hooks/translations-context-provider';
import { StoreContext } from '../../store';
import { TranslationsKeys } from '../../translations';

interface Props {
  style?: CSSProperties;
}
export const Discover = ({ style = {} }: Props) => {
  const rootStore = useContext(StoreContext);
  const translate = useContext(TranslationsContext) as (
    path: TranslationsKeys,
    args?: TranslatorMacroReplace
  ) => string;
  const { discover, name } = rootStore.formatConfig;

  const containerStyle: CSSProperties = {
    backgroundColor: discover.backgroundColor,
    textTransform: discover.uppercase ? 'uppercase' : 'none',
    ...style
  };

  return (
    <div
      className={styles.discoverContainer}
      data-zone="discover"
      style={containerStyle}
    >
      <div
        style={{ color: discover.fontColor }}
        className={styles.titleContainer}
      >
        <div className={styles.brandLabel}>{translate('discover')}</div>
        <div className={styles.brandName}>{name}</div>
      </div>
    </div>
  );
};
